import { render, staticRenderFns } from "./OneCallsDialog.vue?vue&type=template&id=26a51a24&"
import script from "./OneCallsDialog.vue?vue&type=script&lang=js&"
export * from "./OneCallsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports